/* eslint-disable no-template-curly-in-string */
import React, { Component, Fragment } from 'react';
import CelaneseAPI from '../../../services';
import config, { utils } from '../../../config';
import InputField from '../../global/InputField';
import { Button, message, Switch, Modal } from 'antd';
import { Combobox } from 'react-widgets';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Convert from '../../../convert';
import 'react-widgets/dist/css/react-widgets.css';
import './SingleCigarette.css';
import Calculations from '../../../calculations';
import CalculateAvailable from '../../CalculateAvailable';
import TipVent from '../../TipVent';
import { getCigaretteData, getCarbonCigaretteData } from './../../../actions/index';
import Translation from '../../../Translation';

const initialState = {
    pref: {
        weight: ['g/100', 'mg', 'g'],
        lowpdlim: ['mm H₂O', 'pa'],
        pz: ['% Dry Basis', '% Wet Basis'],
        pivmaxlim: ['Tow Weight', 'Wet Weight']
    },

    isDualCigarette: false,
    filter1Data: {},
    filter2Data: {},
    ventType: false,
    isTipVent: false,
    isFetchingFilters: false,
    dualFilterName: '',
    name: '',
    tipPaper: '',
    tipPaperPerm: 0,
    tipVent: 0,
    ventLocation: 0,
    tipEpd: 0,
    columnEpd: 0,
    cigEpd: 0,
    tipUEpd: 0,
    columnUEpd: 0,
    cigUEpd: 0,
    loading: false,
    avlSmoke: 0,
    avlTar: 0,
    avlNic: 0,
    avlEug: 0,
    co0Vent: 0,
    eug0Vent: 0,
    id: null,
    smkdelx: 0,
    tardelx: 0,
    nicdelx: 0,
    codelx: 0,
    eugdelx: 0,
    smkdelo: 0,
    tardelo: 0,
    nicdelo: 0,
    codelo: 0,
    eugdelo: 0,
    errorFilterChange: false,
    finalData: {},
    hotCollapse: {},
    filterId: null,
    dualFilterId: null,
    sharedByName: '',
    calcAvlData: {}
};
/**
 * Class for cigarette design screen
 *
 * @class SingleCigarette
 * @extends {Component}
 */
class SingleCigarette extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
            preferences: this.props.preferences,
            cigaretteData: [],
            isToBeSaved: false,
            saveCigWithoutFilter: false,
            checkPerformSave: false
        };
        this.showHotCollapseScreen = this.showHotCollapseScreen.bind(this);
        this.showCalculateAvailableScreen = this.showCalculateAvailableScreen.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    /**
     * showHotCollapseScreen function is for toggling the view of hot collapse modal popup.
     *
     * @param {boolean} isHotCollapseVisible
     * @param {*} e
     * @memberof SingleCigarette
     */
    showHotCollapseScreen(isHotCollapseVisible, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ isHotCollapseVisible });
    }

    /**
     * showCalculateAvailableScreen function is for toggling the view of calculate available modal popup.
     *
     * @param {boolean} isCalculateAvailableVisible
     * @param {*} e
     * @memberof SingleCigarette
     */
    showCalculateAvailableScreen(isCalculateAvailableVisible, e) {
        if (e) {
            e.preventDefault();
        }
        let calcAvlData = {};
        if (isCalculateAvailableVisible) {
            let filterData = this.state.filter1Data;
            let finalData = this.state.finalData;
            let tipCirc = this.state.isDualCigarette ? finalData.tipcirc : filterData.tipcirc;
            calcAvlData = {
                tipLength: filterData.tiplen,
                tipEpd: filterData.tipepd,
                tipCircumference: tipCirc,
                tipDiam: Convert.toDiameter(tipCirc),
                tipVent: this.state.tipVent,
                isTipVentVisible: this.state.ventType,
                sre: finalData.sre || 0,
                tre: finalData.tre || 0,
                nre: finalData.nre || 0,
                ere: finalData.ere || 0,
                // towItem: filterData.towItem,
                // newDpf: filterData.newDpf,
                // newTd: filterData.newTd,
                // isNewTowitem: filterData.isNewTowitem

            }
        }

        this.setState({
            calcAvlData: calcAvlData,
            isCalculateAvailableVisible: isCalculateAvailableVisible
        });
    }

    componentWillReceiveProps(nextProps) {
        var doRefresh = false;
        var that = this;

        if (this.state.preferences !== nextProps.preferences) {
            this.setState({
                preferences: nextProps.preferences
            });
            doRefresh = true;
        }

        if (this.state.dualFilterId !== nextProps.dualFilterId || this.state.dualFilterName !== nextProps.dualFilterName) {
            this.setState({
                dualFilterName: nextProps.dualFilterName,
                dualFilterId: nextProps.dualFilterId
            }, function () {
                if (nextProps.dualFilterId && nextProps.dualFilterName) {
                    this.setState({
                        isToBeSaved: true,
                        checkPerformSave: true,
                        saveCigWithoutFilter: false
                    });
                    // this.saveCigarette();
                }
            });
        }
        if ((this.state.isDualCigarette && !nextProps.dualFilterId) || (nextProps.filter1Data && !nextProps.filter1Data.filterId) || (nextProps.filter2Data && !nextProps.filter2Data.filterId)) {
            /**  dual filter is not selected --> show popup-alert  **/
            this.setState({
                saveCigWithoutFilter: true,
                dualFilterName: !nextProps.dualFilterName ? '' : nextProps.dualFilterName,
                dualFilterId: !nextProps.dualFilterId ? null : nextProps.dualFilterId,
                filterId: !nextProps.filter1Data.filterId ? null : nextProps.filter1Data.filter1Data,
                isFetchingFilters: false
            });
        }
        if (this.state.preferences !== nextProps.preferences) {
            this.setState({
                preferences: nextProps.preferences
            });
            doRefresh = true;
        }

        if (nextProps && nextProps.filter1Data) {

            if (nextProps.filter1Data.deleted) {
                this.setState({
                    isFetchingFilters: false
                })
            } else if (nextProps.filter1Data.tiplen) {
                this.setState({
                    filter1Data: nextProps.filter1Data
                })
                doRefresh = true;
            }

        }

        if (nextProps && nextProps.combiData && nextProps.combiData.sre) {
            this.setState({
                combiData: nextProps.combiData
            })
            doRefresh = true;
        }

        if (doRefresh) {
            setTimeout(function () {
                that.calculateCigarette();
            }, 300)

        }

        if (typeof nextProps.isDualCigarette === 'boolean') {
            if (this.state.isDualCigarette !== nextProps.isDualCigarette) {
                this.setState({
                    name: '',
                    ...initialState
                }, function () {
                    this.handleFilter();
                });
            }
            this.setState({
                filterId: nextProps.filter1Data ? nextProps.filter1Data.filterId : null,
                filterName: nextProps.filter1Data ? nextProps.filter1Data.name : '',
                isDualCigarette: nextProps.isDualCigarette ? true : false
            }, function () {
                this.assignData(nextProps);
            })
        }
    }

    /**
     * handleFilter is for obtaining the result on every keystorke by comparing the item from the
     * dropdown and the string we enter.
     * 
     * @param {String} item
     * @memberof SingleCigarette
     */
    handleFilter = (item) => {
        let data = this.state.cigaretteData;
        let result = item ? data.find(element => element.id === item.id) : null;
        if (result) {
            this.setState({ isFetchingFilters: true }, function () {
                if (result.name) {
                    result.ventType = (result.ventType === 'true');
                    this.setState({ ...result });
                    this.props.performFilterChange({
                        data: result,
                        isDualCigarette: this.state.isDualCigarette ? true : false
                    });
                }
            });
        } else {
            this.setState({
                id: null
            });
            if (this.state.errorFilterChange) {
                this.setState({
                    errorFilterChange: false,
                    ...initialState
                });
                message.error(utils.getTranslationText('msg_cigarette_deleted', 'Cigarette might be deleted!'));
            }
        }
    }
    success = (msg) => {
        msg && message.success(msg, 2);
    }

    error = () => {
        message.error(utils.getTranslationText('msg_some_issue', 'There was some issue.'), 2);
    }

    warning = (msg) => {
        let def = utils.getTranslationText('msg_required_are_empty', 'Required fields are empty');
        message.warning(msg || def, 2);
    }

    componentWillMount() {
        this.assignData(this.props);
    }

    assignData = (nextProps) => {
        if (nextProps.cigaretteData) {
            this.setState({
                cigaretteData: this.props.isDualCigarette ? nextProps.carbonCigaretteData : nextProps.cigaretteData
            })
        }
        if (nextProps.carbonCigaretteData) {
            this.setState({
                cigaretteData: this.props.isDualCigarette ? nextProps.carbonCigaretteData : nextProps.cigaretteData
            })
        }
    }

    onCalculateAvailableSelect = (data) => {
        if (data) {
            this.setState({
                avlSmoke: data.avlSmoke,
                avlNic: data.avlNic,
                avlTar: data.avlTar,
                avlEug: data.avlEug,
                co0Vent: data.avlCo,
                isCalculateAvailableVisible: false
            }, () => {
                this.calculateCigarette();
            });
        }
    }

    calculateCigarette = (e) => {
        e && e.preventDefault();
        let tipuepd = 0, ciguepd = 0, columnuepd = 0;
        let filter1Data = this.state.filter1Data;
        let combiData = this.state.combiData;
        let tiplen = filter1Data.tiplen;
        let effDel = {
            smkdelx: 0,
            tardelx: 0,
            nicdelx: 0,
            codelx: 0,
            eugdelx: 0,
            smkdelo: 0,
            tardelo: 0,
            nicdelo: 0,
            codelo: 0,
            eugdelo: 0
        };
        let hotCollapse = {};

        let finalData = filter1Data;
        let calculations = Calculations(this.state.preferences);

        let { tipVent } = this.state;

        if (!(filter1Data && filter1Data.tiplen) && !combiData) {
            return;
        }

        if (this.state.isDualCigarette && combiData) {
            finalData = combiData;
        }

        let tipepd = parseFloat(finalData.tipepd);
        let cigEpd = tipepd + parseFloat(this.state.columnEpd);

        tipVent = parseFloat(tipVent);

        if (!this.state.ventType) {
            tipVent = 0;
        }

        tipuepd = tipepd * (1.01 - 0.924 * tipVent / 100);
        if (tipuepd > tipepd) {
            tipuepd = tipepd;
        }

        ciguepd = cigEpd * (1 - tipVent / 100);

        columnuepd = ciguepd - tipuepd;



        if (finalData && finalData.sre) {
            effDel = calculations.removalEfficienciesCalcDelivery({
                avlsmk: this.state.avlSmoke,
                avltar: this.state.avlTar,
                avlnic: this.state.avlNic,
                avleug: this.state.avlEug,
                codelo: parseFloat(this.state.co0Vent),
                sre: finalData.sre,
                tre: finalData.tre,
                nre: finalData.nre,
                ere: finalData.ere,
                tipvent: tipVent,
                tipcirc: finalData.tipcirc,
                carbonTip: finalData.tipsrod * tiplen
            });

            if (!(this.state.isDualCigarette && this.state.preferences.kretek)) {
                hotCollapse = calculations.hotCollapse({
                    sre: finalData.sre,
                    tipsrod: finalData.tipsrod,
                    ndpf: finalData.ndpf,
                    pz: finalData.pz,
                    avlsmk: this.state.avlSmoke,
                    tipvent: tipVent,
                    towowt: finalData.towowt
                });

                hotCollapse.tipLoad = hotCollapse.tipLoad && parseFloat(hotCollapse.tipLoad.toFixed(2));
                hotCollapse.hotC = hotCollapse.hotC && parseFloat(hotCollapse.hotC.toFixed(2));
            }
        }

        this.setState({
            cigUEpd: parseFloat(ciguepd.toFixed(2)),
            tipUEpd: parseFloat(tipuepd.toFixed(2)),
            columnUEpd: parseFloat(columnuepd.toFixed(2)),
            tipEpd: parseFloat(tipepd.toFixed(2)),
            cigEpd: parseFloat(cigEpd.toFixed(2)),
            smkdelx: parseFloat(effDel.smkdelx.toFixed(2)),
            tardelx: parseFloat(effDel.tardelx.toFixed(2)),
            nicdelx: parseFloat(effDel.nicdelx.toFixed(2)),
            codelx: parseFloat(effDel.codelx.toFixed(2)),
            eugdelx: parseFloat(effDel.eugdelx.toFixed(2)),
            smkdelo: parseFloat(effDel.smkdelo.toFixed(2)),
            tardelo: parseFloat(effDel.tardelo.toFixed(2)),
            nicdelo: parseFloat(effDel.nicdelo.toFixed(2)),
            codelo: parseFloat(effDel.codelo.toFixed(2)),
            eugdelo: parseFloat(effDel.eugdelo.toFixed(2)),
            isFetchingFilters: false,
            finalData: finalData,
            hotCollapse: hotCollapse,
            showHotCollapse: !filter1Data.hasCload && !this.state.isDualCigarette && !this.state.preferences.kretek
        });
    }

    saveCigarette = (e) => {
        e && e.preventDefault();
        let _this = this;
        let _thisState = this.state;
        let dataObj = {
            "name": _thisState.name.replace(/ \((Shared).*/, ''),
            "ventType": _thisState.ventType,
            "tipPaper": _thisState.tipPaper,
            "tipVent": parseFloat(_thisState.tipVent),
            "columnEpd": parseFloat(_thisState.columnEpd),
            "ventLocation": parseFloat(_thisState.ventLocation),
            "tipPaperPerm": parseFloat(_thisState.tipPaperPerm),
            "avlSmoke": parseFloat(_thisState.avlSmoke),
            "avlTar": parseFloat(_thisState.avlTar),
            "avlNic": parseFloat(_thisState.avlNic),
            "avlEug": parseFloat(_thisState.avlEug),
            "co0Vent": parseFloat(_thisState.co0Vent),
            "eug0Vent": parseFloat(_thisState.eug0Vent)
        };

        if (!_thisState.name) {
            this.warning(utils.getTranslationText('msg_plz_enter_cigarette_name', 'Please enter the cigarette name'));
            return;
        }

        if (!((!this.state.isDualCigarette && _thisState.filterName) || (this.state.isDualCigarette && _thisState.dualFilterName))) {
            this.warning(utils.getTranslationText('msg_filter_combined_data_missing', 'Filter or Combined filter data is missing'));
            return;
        }

        if (this.state.isDualCigarette) {
            dataObj.dualFilterName = _thisState.dualFilterName;
            dataObj.dualFilterId = _thisState.dualFilterId;
        } else {
            dataObj.filterId = _thisState.filterId;
            dataObj.filterName = _thisState.filterName;
        }

        this.setState({
            loading: true,
            isToBeSaved: true,
            saveCigWithoutFilter: this.state.isDualCigarette ? (_thisState.dualFilterId && _thisState.filterId ? false : true) : (_thisState.filterId ? false : true)
        }, function () {
            if (this.state.saveCigWithoutFilter) {
                Modal.error({
                    title: utils.getTranslationText('msg_cannot_save_the_cigarette', 'Cannot Save the Cigarette'),
                    content: utils.getTranslationText('msg_looks_like_filter_combined_filter', 'Looks like Filter/Combined Filter are cloned and not saved, Please save it and try to save the Cigarette'),
                    okText: utils.getTranslationText('btn_ok', 'OK'),
                    okType: 'info',
                    cancelText: null,
                    onOk() {
                        _this.setState({ saveCigWithoutFilter: false, loading: false });
                    },
                    onCancel() {

                    },
                })
            }
            else {
                if (this.props.performSave && this.state.checkPerformSave) {
                    this.props.performSave();
                    this.setState({
                        checkPerformSave: false
                    })
                }

                if (dataObj.name && (this.state.isDualCigarette ? _thisState.dualFilterId : dataObj.filterId)) {
                    this.setState({
                        isToBeSaved: false
                    }, function () {
                        let promiseObj;
                        if (this.state.id) {
                            promiseObj = CelaneseAPI.patch(this.state.isDualCigarette ? config.API.carbonCigarette + '/' + this.state.id : config.API.cigarette + '/' + this.state.id, dataObj);
                        } else {
                            promiseObj = CelaneseAPI.post(this.state.isDualCigarette ? config.API.carbonCigarette : config.API.cigarette, dataObj);
                        }
                        promiseObj.then(res => {
                            if (res.data) {
                                let data = res.data instanceof Array ? res.data[0] : res.data;
                                if (this.state.id) {
                                    this.success(utils.getTranslationText('msg_cgrt_updated_success', "Cigarette '${name}' is Updated Successfully").replace('${name}', this.state.name));
                                } else {
                                    this.success(utils.getTranslationText('msg_new_cgrt_created_success', "New Cigarette '${name}' is created Successfully").replace('${name}', this.state.name));
                                }
                                this.setState({
                                    loading: false,
                                    id: data.id
                                });
                                this.state.isDualCigarette ? getCarbonCigaretteData().then(res => {
                                    return res;
                                }) : getCigaretteData().then(res => {
                                    return res;
                                });
                            } else {
                                this.setState({
                                    loading: false
                                });
                                this.error();
                            }
                        }).catch(() => {
                            this.setState({
                                loading: false
                            });
                            this.error();
                        });
                    });
                } else {
                    this.setState({
                        loading: false
                    });
                }
            }
        });
    }

    calculateAvailable = (e) => {
        e.preventDefault();
    }

    hotCollapse = (e) => {
        e.preventDefault();
    }

    showTipVentModal = () => {
        this.setState({
            isTipVentVisible: true
        })
    }

    showTipForForm = (isTipVentVisible, e) => {
        e && e.preventDefault();
        this.setState({ isTipVentVisible });
    }

    updateTipValue = (value) => {
        this.setState({
            tipVent: value
        });
    }

    toggleVentType = () => {
        this.setState({ ventType: !this.state.ventType });
    }

    render() {
        let ListItem = ({ item }) => (
            <Fragment>
                {item.name} <i>{" " + item.displayName}</i>
            </Fragment>
        );
        return (
            <div className='cigarette-wrapper col-md-12'>
                <div className='col-md-5 m2-top '>
                    <div className='row'>
                        <div className='cigarette-wrapper__field col-md-6'>
                            <label><Translation labelName="lbl_cigarette_brand" defaultText="Cigarette Brand" />:<i>{this.state.sharedByName ? this.state.sharedByName : null}</i></label>
                            <Combobox
                                caseSensitive={false}
                                busy={this.state.isFetchingFilters}
                                onChange={(obj) => {
                                    let sharedByName = '';

                                    if (typeof obj === 'object' && obj.name && obj.isShared) {
                                        sharedByName = obj.displayName;
                                    } else if (typeof obj === 'string' && obj.length > 30) {
                                        return;
                                    }

                                    this.setState({
                                        name: obj.name || obj,
                                        id: obj.id || null,
                                        sharedByName: sharedByName
                                    }, function () {
                                        this.handleFilter(obj)
                                    })
                                }
                                }
                                data={(this.state.cigaretteData) ? this.state.cigaretteData : []}
                                messages={{
                                    emptyList: <Translation labelName="msg_there_r_no_items_list" defaultText="There are no items in this list"/> ,
                                  }}
                                textField='name'
                                valueField='id'
                                itemComponent={ListItem}
                            />
                        </div>
                        <div className='cigarette-wrapper__field col-md-2'>
                            <label><Translation labelName="opt_ventilated" defaultText="Ventilated" /></label>
                            <Switch
                                checked={typeof this.state.ventType === 'string' ? (this.state.ventType === 'true') : this.state.ventType}
                                checkedChildren={<Translation labelName="lbl_yes" defaultText="Yes" />}
                                unCheckedChildren={<Translation labelName="lbl_no" defaultText="No" />}
                                onChange={this.toggleVentType}
                            />
                        </div>
                        <div className='cigarette-wrapper__field col-md-4'>
                            {this.state.ventType ?
                                <InputField
                                    type='number'
                                    label={<Translation labelName="lbl_cigarette_design_tip_ventilation" defaultText="Tip Ventilation" />}
                                    name='tipVent'
                                    value={this.state.tipVent}
                                    id='tipVent'
                                    min='0'
                                    max='100'
                                    buttonIcon='setting'
                                    onButtonClick={this.showTipVentModal}
                                    errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-100" defaultText="value is not between 0 - 100" />}
                                    onChange={(event) => this.handleChange(event)}
                                    className='plugwrap col-md-12'
                                /> : ''}
                        </div>
                    </div>
                    <div className="row">
                        <InputField
                            type='number'
                            label={<Translation labelName="lbl_tip_epd" defaultText="Tip EPD" />}
                            name='tipEpd'
                            units={'(' + this.state.pref.lowpdlim[this.state.preferences.lowpdlim - 1] + ')'}
                            min='0'
                            max='1000'
                            errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-1000" defaultText="value is not between 0 - 1000" />}
                            value={this.state.tipEpd}
                            disabled={true}
                            id='tipEpd'
                            onChange={(event) => this.handleChange(event)}
                            className='cigarette-wrapper__field col-md-4'
                        />
                        <InputField
                            type='number'
                            label={<Translation labelName="lbl_column_epd" defaultText="Column EPD" />}
                            name='columnEpd'
                            units={'(' + this.state.pref.lowpdlim[this.state.preferences.lowpdlim - 1] + ')'}
                            min='0'
                            max='1000'
                            errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-1000" defaultText="value is not between 0 - 1000" />}
                            value={this.state.columnEpd}
                            id='columnEpd'
                            onChange={(event) => this.handleChange(event)}
                            className='cigarette-wrapper__field col-md-4'
                        />
                        <InputField
                            type='number'
                            label={<Translation labelName="lbl_cigarette_epd" defaultText="Cigarette EPD" />}
                            name='cigEpd'
                            units={'(' + this.state.pref.lowpdlim[this.state.preferences.lowpdlim - 1] + ')'}
                            min='0'
                            max='1000'
                            errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-1000" defaultText="value is not between 0 - 1000" />}
                            value={this.state.cigEpd}
                            disabled={true}
                            id='cigEpd'
                            onChange={(event) => this.handleChange(event)}
                            className='cigarette-wrapper__field col-md-4'
                        />
                    </div>
                    {this.state.ventType ? <div className='row'>
                        <InputField
                            type='number'
                            label={<Translation labelName="lbl_tip_uepd" defaultText="Tip UEPD" />}
                            name='tipUEpd'
                            units={'(' + this.state.pref.lowpdlim[this.state.preferences.lowpdlim - 1] + ')'}
                            min='0'
                            max='1000'
                            errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-1000" defaultText="value is not between 0 - 1000" />}
                            value={this.state.tipUEpd}
                            disabled={true}
                            id='tipUEpd'
                            onChange={(event) => this.handleChange(event)}
                            className='cigarette-wrapper__field col-md-4'
                        />
                        <InputField
                            type='number'
                            label={<Translation labelName="lbl_column_uepd" defaultText="Column UEPD" />}
                            name='columnUEpd'
                            units={'(' + this.state.pref.lowpdlim[this.state.preferences.lowpdlim - 1] + ')'}
                            min='0'
                            max='1000'
                            errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-1000" defaultText="value is not between 0 - 1000" />}
                            value={this.state.columnUEpd}
                            disabled={true}
                            id='columnUEpd'
                            onChange={(event) => this.handleChange(event)}
                            className='cigarette-wrapper__field col-md-4'
                        />
                        <InputField
                            type='number'
                            label={<Translation labelName="lbl_cigarette_uepd" defaultText="Cigarette UEPD" />}
                            name='cigUEpd'
                            units={'(' + this.state.pref.lowpdlim[this.state.preferences.lowpdlim - 1] + ')'}
                            min='0'
                            max='1000'
                            errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-1000" defaultText="value is not between 0 - 1000" />}
                            value={this.state.cigUEpd}
                            disabled={true}
                            id='cigUEpd'
                            onChange={(event) => this.handleChange(event)}
                            className='cigarette-wrapper__field col-md-4'
                        />
                    </div> : ''}
                    {this.state.showHotCollapse ?
                        <div className="row">
                            <div className="col-md-8">
                                <div className="carbon-container">
                                    <InputField
                                        type='number'
                                        label={<Translation labelName="lbl_hot_collapse" defaultText="Hot Collapse" />}
                                        name='hotcollapse'
                                        units={<Fragment>(<Translation labelName="units_%" defaultText="%" />)</Fragment>}
                                        value={this.state.hotCollapse.hotC || 0}
                                        disabled={true}
                                        id='hotCo'
                                        className='cigarette-wrapper__field col-md-6'
                                    />
                                    <InputField
                                        type='number'
                                        label={<Translation labelName="lbl_tip_load" defaultText="Tip Load" />}
                                        name='tipload'
                                        units={<Fragment>(<Translation labelName="units_%" defaultText="%" />)</Fragment>}
                                        value={this.state.hotCollapse.tipLoad || 0}
                                        disabled={true}
                                        id='tipload'
                                        className='cigarette-wrapper__field col-md-6'
                                    />

                                    {/* <a href='/help/html/Hot_Collapse.htm' title="Help" target="_blank" className="help-section hot-collapse-help">
                                        <img
                                            src="./images/help-inverse-black.svg"
                                            width="16"
                                            alt="help"
                                            className="help-icon" />
                                    </a> */}
                                </div>
                            </div>
                        </div> : ''}
                    <div className='row'>
                        <div className='col-md-12 cigarette-wrapper-links p2-bottom'>
                            <Button
                                className="calculate-link btn btn-primary"
                                type="primary"
                                disabled={this.state.isFetchingFilters}
                                onClick={() => { this.props.performCalculate() }}
                            >
                                <Translation labelName="btn_calculate" defaultText="Calculate" />
                            </Button>
                            <Button
                                className="save-link btn btn-primary"
                                type="primary"
                                onClick={(e) => this.saveCigarette(e)}
                                loading={this.state.loading}
                                disabled={
                                    this.state.isFetchingFilters || (!(this.state.name) && !(this.state.ventType && this.state.tipVent))
                                }
                            ><Translation labelName="btn_save" defaultText="Save" /></Button>

                        </div>
                    </div>
                </div>
                <div className="col-md-7 m2-top m2-bottom">
                    <div className={this.state.preferences.kretek ? 'cigarette-wrapper-calculation isKretek' : 'cigarette-wrapper-calculation'}>
                        <ul className='cigarette-list-heading'>
                            <li><h4><Translation labelName="lbl_smoke" defaultText="Smoke"></Translation></h4></li>
                            <li><h4><Translation labelName="lbl_tar" defaultText="Tar"></Translation></h4></li>
                            <li><h4><Translation labelName="lbl_nicotine" defaultText="Nicotine"></Translation></h4></li>
                            <li><h4><Translation labelName="lbl_co" defaultText="CO"></Translation></h4></li>
                            {this.state.preferences.kretek ? <li><h4><Translation labelName="lbl_eugenol" defaultText="Eugenol"></Translation></h4></li> : ''}
                            <li><h4></h4></li>
                        </ul>
                        <ul>
                            <li>
                                <InputField
                                    type='number'
                                    label=''
                                    name='avlSmoke'
                                    min='0'
                                    max='100'
                                    errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-100" defaultText="value is not between 0 - 100" />}
                                    value={this.state.avlSmoke}
                                    id='avlSmoke'
                                    onChange={(event) => this.handleChange(event)}
                                    className='cigarette-wrapper__field'
                                />
                            </li>
                            <li>
                                <InputField
                                    type='number'
                                    label=''
                                    name='avlTar'
                                    min='0'
                                    max='100'
                                    errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-100" defaultText="value is not between 0 - 100" />}
                                    value={this.state.avlTar}
                                    id='avlTar'
                                    onChange={(event) => this.handleChange(event)}
                                    className='cigarette-wrapper__field'
                                />
                            </li>
                            <li>
                                <InputField
                                    type='number'
                                    label=''
                                    name='avlNic'
                                    min='0'
                                    max='100'
                                    errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-100" defaultText="value is not between 0 - 100" />}
                                    value={this.state.avlNic}
                                    id='avlNic'
                                    onChange={(event) => this.handleChange(event)}
                                    className='cigarette-wrapper__field'
                                />
                            </li>
                            <li></li>
                            {this.state.preferences.kretek ? <li>
                                <InputField
                                    type='number'
                                    label=''
                                    name='avlEug'
                                    min='0'
                                    max='100'
                                    errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-100" defaultText="value is not between 0 - 100" />}
                                    value={this.state.avlEug}
                                    id='avlEug'
                                    onChange={(event) => this.handleChange(event)}
                                    className='cigarette-wrapper__field'
                                />
                            </li> : ''}
                            <li><h4><Translation labelName="lbl_cigarette_listing_available" defaultText="Available" /> (<span><Translation labelName="units_mg_cig" defaultText="mg/cig" /></span>)</h4></li>
                        </ul>
                        <ul>
                            <li><h4>{this.state.finalData.sre || 0}</h4></li>
                            <li><h4>{this.state.finalData.tre || 0}</h4></li>
                            <li><h4>{this.state.finalData.nre || 0}</h4></li>
                            <li><h4></h4></li>
                            {this.state.preferences.kretek ? <li><h4>{this.state.finalData.ere || 0}</h4></li> : ''}
                            <li><h4><Translation labelName="lbl_cigarette_listing_removal" defaultText="Removal Efficiency" /> (%)</h4></li>
                        </ul>
                        <ul>
                            <li><h4>{this.state.smkdelo}</h4></li>
                            <li><h4>{this.state.tardelo}</h4></li>
                            <li><h4>{this.state.nicdelo}</h4></li>
                            <li>
                                <InputField
                                    type='number'
                                    label=''
                                    name='co0Vent'
                                    min='0'
                                    max='100'
                                    errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-100" defaultText="value is not between 0 - 100" />}
                                    value={this.state.co0Vent}
                                    id='co0Vent'
                                    onChange={(event) => this.handleChange(event)}
                                    className='cigarette-wrapper__field'
                                />
                            </li>
                            {this.state.preferences.kretek ? <li><h4>{this.state.eugdelo}</h4></li> : ''}
                            <li><h4><Translation labelName="lbl_cigarette_listing_delivery" defaultText="Delivery not ventilated" /> (<span><Translation labelName="units_mg_cig" defaultText="mg/cig" /></span>)</h4></li>
                        </ul>
                        {this.state.ventType ? <ul>
                            <li><h4>{this.state.smkdelx}</h4></li>
                            <li><h4>{this.state.tardelx}</h4></li>
                            <li><h4>{this.state.nicdelx}</h4></li>
                            <li><h4>{this.state.codelx}</h4></li>
                            {this.state.preferences.kretek ? <li><h4>{this.state.eugdelx}</h4></li> : ''}
                            <li><h4><Translation labelName="lbl_delivery_at" defaultText="Delivery at" /> {this.state.tipVent}<Translation labelName="lbl_ventilation" defaultText="% ventilation" /> (<span><Translation labelName="units_mg_cig" defaultText="mg/cig" /></span>)</h4></li>
                        </ul> : ''}
                        <div className='cigarette-wrapper-links'>

                            {/* <Button 
                                className="save-link btn btn-primary"
                                type="primary"
                                onClick={(e) => this.showHotCollapseScreen(true, e)}
                            >Hot Collapse</Button> */}

                            <Button
                                className="calculate-link btn btn-primary margin-right-none"
                                type="primary"
                                onClick={(e) => this.showCalculateAvailableScreen(true, e)}
                            >
                                <Translation labelName="lbl_calculate_available" defaultText="Calculate Available" />
                            </Button>
                        </div>
                    </div>
                </div>
                {this.state.isCalculateAvailableVisible && <CalculateAvailable
                    tipData={this.state.calcAvlData}
                    isCalculateAvailableVisible={this.state.isCalculateAvailableVisible}
                    showCalculateAvailableScreen={this.showCalculateAvailableScreen}
                    onSelect={this.onCalculateAvailableSelect}
                ></CalculateAvailable>}
                {
                    this.state.isTipVentVisible && <TipVent
                        isTipVisible={this.state.isTipVentVisible}
                        showTipForForm={this.showTipForForm}
                        updateTipValue={this.updateTipValue}>
                    </TipVent>
                }
            </div>
        );
    }
}

const mapStateToProps = ({ loggedUserState, filtersState }) => ({
    preferences: loggedUserState.prefData && loggedUserState.prefData.preferences,
    cigaretteData: filtersState.cigaretteData,
    carbonCigaretteData: filtersState.carbonCigaretteData
});

export default connect(mapStateToProps, null)(SingleCigarette);

SingleCigarette.propTypes = {
    preferences: PropTypes.object,
    isDualCigarette: PropTypes.bool,
    dualFilterName: PropTypes.any,
    filter1Data: PropTypes.object,
    filter2Data: PropTypes.object,
    performFilterChange: PropTypes.func,
    combiData: PropTypes.object,
    cigaretteData: PropTypes.array,
    carbonCigaretteData: PropTypes.array,
    getCigaretteData: PropTypes.func,
    getCarbonCigaretteData: PropTypes.func,
    performSave: PropTypes.func,
    performCalculate: PropTypes.func,
    dualFilterId: PropTypes.any
};


// WEBPACK FOOTER //
// ./src/components/Cigarette/SingleCigarette/index.js